module.exports = __webpack_public_path__ + "static/media/connectIps.dfa033e1.png";